<template>
<div>
      <CCard class="h-100">
      <CRow>
        <CCol sm="12" class="justify-content-center m-0">
          <CContainer>
            <CCol sm="12" lg="12">
              <CRow>
                <div class="col-12">
                  <Countdown :date="end" @onFinish="finish()"></Countdown>
                </div>
              </CRow>
              <CCard style="max-width:100%" class="p-1 mt-5">
                <div class=" ml-3 mr-3 mt-3 mb-2">

              <h5
                class="text-left text-black bold d-flex display-6"
              >
                <span v-html="questionDetail.questionNo"></span>.
                <span v-html="questionDetail.questionName" style="max-width:100%"></span>
            </h5>
              <div
                class="col-12 text-center"
                v-if="questionDetail.questionImagePath != null"
              >
                <div style="float: right" class="mb-2">
                  <CButton color="info" type="submit" v-on:click="PrintSection">
                    <i class="fa icon-printer"></i> Download Image
                  </CButton>
                </div>
                <br />
                <div style="clear: both"></div>
                <CRow class="justify-content-center">
                  <CCard
                    style="background: #ffffff; border: #000000; width: 100%"
                    class="box-shadow"
                    @click="FullImage()"
                  >
                    <div id="printsection">
                      <img
                        style="max-width: 100%; height: 200px"
                        class="image"
                        :src="getPic(questionDetail)"
                      />
                    </div>
                  </CCard>
                </CRow>
              </div>

              <div class="mt-4">
                <p
                  style="margin-bottom: 0px"
                  v-if="questionDetail.choiceA != null"
                >
                  A. {{ questionDetail.choiceA }}
                </p>
                <p
                  style="margin-bottom: 0px"
                  v-if="questionDetail.choiceB != null"
                >
                  B. {{ questionDetail.choiceB }}
                </p>
                <p
                  style="margin-bottom: 0px"
                  v-if="questionDetail.choiceC != null"
                >
                  C. {{ questionDetail.choiceC }}
                </p>
                <p
                  style="margin-bottom: 0px"
                  v-if="questionDetail.choiceD != null"
                >
                  D. {{ questionDetail.choiceD }}
                </p>
                <p
                  style="margin-bottom: 0px"
                  v-if="questionDetail.choiceE != null"
                >
                  E. {{ questionDetail.choiceE }}
                </p>
                <p
                  style="margin-bottom: 0px"
                  v-if="questionDetail.choiceF != null"
                >
                  F. {{ questionDetail.choiceF }}
                </p>
                <p
                  style="margin-bottom: 0px"
                  v-if="questionDetail.choiceG != null"
                >
                  G. {{ questionDetail.choiceG }}
                </p>
              </div>

              <CRow>
                <div
                  class="mx-auto d-flex justify-content-center col-12 ml-4 mt-1"
                >
                  <div class="text-center custom-width-lg">
                    <CRow class="justify-content-center">
                      <CCol sm="12" lg="12" class="mt-4" style="display: flex">
                        <span sm="6" lg="6" style="flex: 2">
                          <form>
                            <label>
                              <input
                                type="radio"
                                name="radio"
                                checked
                                v-model="answer"
                                value="1"
                              />
                              <span>A</span>
                            </label>

                            <label>
                              <input
                                type="radio"
                                name="radio"
                                v-model="answer"
                                value="2"
                              />
                              <span>B</span>
                            </label>
                          </form>
                        </span>
                      </CCol>

                      <CCol sm="12" lg="12" class="mt-4" style="display: flex">
                        <span sm="6" lg="6" style="flex: 2">
                          <form>
                            <label>
                              <input
                                type="radio"
                                name="radio"
                                checked
                                v-model="answer"
                                value="3"
                              />
                              <span>C</span>
                            </label>

                            <label>
                              <input
                                type="radio"
                                name="radio"
                                v-model="answer"
                                value="4"
                              />
                              <span>D</span>
                            </label>
                          </form>
                        </span>
                      </CCol>

                      <CCol sm="12" class="text-right">
                        <CButton
                          color="primary"
                          class="mt-4 mb-4 float-right"
                          size="lg"
                          @click="SubmitAnswer"
                          >Next
                          <div>
                            <CIcon name="cil-arrow-right" />
                          </div>
                        </CButton>
                      </CCol>
                    </CRow>
                  </div>
                </div>
              </CRow>
                </div>
              </CCard>
            </CCol>
          </CContainer>
        </CCol>
      </CRow>
    </CCard>

    <!-- View Full Image  -->
    <CModal class="col-12" :show.sync="ImageModal">
      <CRow class="justify-content-center">
        <CCard>
          <pinch-zoom>
            <img
              style="max-width: 100%; height: 300px"
              class="imageFull"
              :src="getPic(questionDetail)"
            />
          </pinch-zoom>
        </CCard>
      </CRow>
      <template class="modal-footer" hidden="true" #footer>
        <span></span>
      </template>
    </CModal>
</div>
</template>


<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import moment from "moment";
import backgroundBanner from "../assets/img/bgApps.jpg";
import _ from "lodash";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-timepicker", VueTimepicker);
Vue.component("v-select", vSelect);
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
import Countdown from "../containers/Countdown.vue";
import objectFitImages from "object-fit-images";

import PinchZoom from "vue-pinch-zoom";

Vue.component("pinch-zoom", PinchZoom);
import VueHtmlToPaper from "vue-html-to-paper";
const options = {
  name: "_blank",
  styles: [
    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
    "https://unpkg.com/kidlat-css/css/kidlat.css",
    "../assets/css/pagebreak.css",
  ],
};
Vue.use(VueHtmlToPaper, options);

// Tell Vue to install the plugin.
Vue.use(VuejsDialog);

export default {
  name: "Login",
  components: {
    PulseLoader,
    Countdown,
  },
  data() {
    return {
      backgroundBanner,
      questionDetail: {},
      SubmittedForm: false,
      answer: "",
      ImageModal: false,
      end: this.$route.query.endTime,
      Error: false,
    };
  },
  async mounted() {
    this.GetQuestion();
  },
  computed: {
    isDisabled: function () {
      return !this.SelectedSubject.Id || !this.SelectedGrade.Id;
    },
  },
  methods: {
    PrintSection() {
      this.$htmlToPaper("printsection");
    },
    getPic(questionDetail) {
      return (
        "https://pickiddo.com/Quiz/" +
        questionDetail.questionFolderName +
        "/" +
        questionDetail.questionImageName
      );
    },
    //Get question
    async GetQuestion() {
      this.$API
        .get(
          this.$QuizQuestion +
            "?quizId=" +
            this.$route.query.quizId +
            "&studentId=" +
            this.$route.query.studentId +
            "&startId=" +
            this.$route.query.startId,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.questionDetail = response.data;
            // this.timer = parseFloat(this.questionDetail.timer);
            if (this.questionDetail == "empty") {
              this.GoToPageScore();
            }
          }
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    FullImage() {
      this.ImageModal = true;
    },
    async SubmitAnswer() {
      const formData = new FormData();
      formData.append("QuizTitleId", this.$route.query.quizId);
      formData.append("StudentId", this.$route.query.studentId);
      formData.append("QuizStartId", this.$route.query.startId);
      formData.append("QuizQuestionId", this.questionDetail.questionId);

      if (this.answer === "1") {
        formData.append("ChoiceA", true);
        formData.append("Answer", this.questionDetail.choiceA);
      } else if (this.answer === "2") {
        formData.append("ChoiceB", true);
        formData.append("Answer", this.questionDetail.choiceB);
      } else if (this.answer === "3") {
        formData.append("ChoiceC", true);
        formData.append("Answer", this.questionDetail.choiceC);
      } else if (this.answer === "4") {
        formData.append("ChoiceD", true);
        formData.append("Answer", this.questionDetail.choiceD);
      } else if (this.answer === "5") {
        formData.append("ChoiceE", true);
        formData.append("Answer", this.questionDetail.choiceE);
      } else if (this.answer === "6") {
        formData.append("ChoiceF", true);
        formData.append("Answer", this.questionDetail.choiceF);
      } else {
        formData.append("ChoiceG", true);
        formData.append("Answer", this.questionDetail.choiceG);
      }

      return this.$API
        .post(this.$StudentSubmitAnswer, formData, {
          withCredentials: true,
        })
        .then((response) => {
          console.log(response.status);
          console.log(response.data);
          if (response.status == 200 && response.data != null) {
            var startId = response.data;
            this.GoToRefresh();
          }
        })
        .catch((error) => {
          if (error.response) {
            this.Busy = false;
            this.Error = true;
            console.log(error.response.data);
          }
        });
    },
    finish() {
      this.GoToPageScore();
    },
    GoToRefresh() {
      window.location.reload();
    },
    GoToPageScore() {
      this.$router.push(
        "/QuizStudentFinalScore?studentId=" +
          this.$route.query.studentId +
          "&quizId=" +
          this.$route.query.quizId +
          "&startId=" +
          this.$route.query.startId +
          "&userId=" +
          this.$route.query.userId
      );
    },
  },
};
</script>


<style>
.imageFull {
  object-fit: fill;
  object-position: center;
  font-family: "object-fit: fill; object-position: center;";
}

*:after,
*:before {
  box-sizing: border-box;
}

form {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
}

label {
  display: flex;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-bottom: 0.375em;
  font-size: calc(1em + 1.25vw);
  color: #000021;
  width: 200px;
  padding-right: 10px;
  padding-left: 30px;
  padding-top: 10px;
  /* Accessible outline */
  /* Remove comment to use */
  /*
      &:focus-within {
          outline: .125em solid $primary-color;
      }
    */
}

label input {
  position: absolute;
  left: -9999px;
}

label input:checked + span {
  background-color: #d6d6e5;
  width: 200px;
}
form {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
}

label {
  display: flex;
  cursor: pointer;
  font-weight: 500;
  position: relative;
  overflow: hidden;
  margin-bottom: 0.375em;
  font-size: calc(1em + 1.25vw);
  color: #000021;
  width: 160px;
  padding-right: 20px;
  padding-left: 0px;
  padding-top: 10px;
  padding-bottom: 10px;

  /* Accessible outline */
  /* Remove comment to use */
  /*
  	&:focus-within {
  			outline: .125em solid $primary-color;
  	}
  */
}
label input {
  position: absolute;
  left: -9999px;
}
label input:checked + span {
  background-color: #d6d6e5;
  width: 160px;
  box-shadow: 0 3px 5px 0 rgba(0, 0, 1, 0.2), 0 3px 5px 0 rgba(0, 0, 0, 0.19);
}
label input:checked + span:before {
  box-shadow: inset 0 0 0 0.4375em #00005c;
}
label span {
  display: flex;
  align-items: center;
  padding: 0.375em 0.75em 0.375em 0.375em;
  border-radius: 99em;
  transition: 0.25s ease;
  border: solid 2px rgb(90, 8, 138);
  width: 160px;
}
label span:hover {
  background-color: #d6d6e5;

  width: 160px;
}
label span:before {
  display: flex;
  flex-shrink: 0;
  content: "";
  background-color: #fff;
  width: 1.5em;
  height: 1.5em;
  border-radius: 50%;
  margin-right: 2.3em;
  transition: 0.25s ease;
  box-shadow: inset 0 0 0 0.125em #00005c;
}

label input:checked + span:before {
  box-shadow: inset 0 0 0 0.4375em #00005c;
}

label span {
  display: flex;
  align-items: center;
  padding: 0.375em 0.75em 0.375em 0.375em;
  border-radius: 99em;
  transition: 0.25s ease;
  border: solid 1px blue;
  width: 160px;
}

label span:hover {
  background-color: #d6d6e5;
  width: 160px;
}

label span:before {
  display: flex;
  flex-shrink: 0;
  content: "";
  background-color: #fff;
  width: 1.5em;
  height: 1.5em;
  border-radius: 50%;
  margin-right: 2.3em;
  transition: 0.25s ease;
  box-shadow: inset 0 0 0 0.125em #00005c;
}

.image {
  -o-object-fit: none;
  object-fit: contain;
  -o-object-position: center;
  object-position: center;
}

@media only screen and (min-width: 700px) {
  label {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    cursor: pointer;
    font-weight: 500;
    position: relative;
    overflow: hidden;
    margin-bottom: 0.375em;
    font-size: larger;
    color: #000021;
    width: 235px;
    padding-right: 10px;
    padding-left: 30px;
    padding-top: 10px;
    padding-bottom: 10px;
  }
}
p img {
  width:100% !important;
}
</style>